// export const baseUrl = "https://property-crm.cyberx-infosystem.us/api/c1/"

export const baseUrl = "https://admin.dihenneberry.com.au/api/c1/"
